<template>
  <div class="main_right electronic-config-modify">
    <breadcrumb :breadcrumb="config.breadcrumb"/>
    <div class="flexBox">
      <text-title mainTitle="收费配置" subheading="" />
      <div>
        <a @click="updateElectricPayConfig">保存</a>
        <a @click="cel">取消</a>
      </div>
    </div>

    <form>
      <div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">收费标准：</span>
          </div>
          <el-select v-model="feeType" size="small" style="width: 240px">
            <el-option v-for="item in feeTypeList" :key="item.code"
                       :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="feeType === '1'">
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">固定定价(含服务费)：</span>
          </div>
          <el-input v-model="fixedObj.unitPrice" size="small" style="width: 240px" v-on:blur="fixedObjUnitPriceChange()">
            <template slot="append">元</template>
          </el-input>
        </div>
      </div>
      <div v-if="feeType === '2' && dataLine.showOnPage" v-for="(dataLine, dataLineIndex) in ladderData">
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">用电类型：</span>
          </div>
          <el-select v-model="dataLine.elePayType" size="small" style="width: 240px">
            <el-option v-for="item in elePayTypeList" :key="item.code"
                       :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">收费单价：</span>
          </div>
          <el-input v-model="dataLine.unitPrice" size="small" style="width: 240px" v-on:blur="dataLineUnitPriceChange(dataLine)">
            <template slot="append">元</template>
          </el-input>
        </div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">收费时间：</span>
          </div>
          <el-time-picker is-range v-model="dataLine.timeDataLine" :key="dataLineIndex" format="HH:mm" value-format="HH:mm" range-separator="至" start-placeholder="开始时间" size="small" end-placeholder="结束时间" placeholder="选择时间范围" style="width: 240px;"></el-time-picker>
        </div>
        <div class="form-line" style="margin-left: 10px;" v-if="3 < dataLineIndex ">
          <i class="el-icon-remove-outline" style="font-size: 18px;color: #f25721;margin: 5px 10px 5px 0;cursor: pointer;" @click="removeDataLine(dataLineIndex)"></i>
        </div>
        <div class="form-line" style="margin-left: 10px;" v-if="dataLineIndex < ladderData.length - 2 && !ladderData[dataLineIndex + 1].showOnPage">
          <i class="el-icon-circle-plus-outline" style="font-size: 18px;color: #00A0E6;margin: 5px 10px 5px 0;cursor: pointer;" @click="addDataLine(dataLineIndex)"></i>
        </div>
      </div>
      <div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">服务费单价：</span>
          </div>
          <el-input v-model="serviceFee" size="small" style="width: 240px" v-on:blur="fixedServiceFeeChange()">
            <template slot="append">元</template>
          </el-input>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import {pattern} from '../../../utils/regular'
  import {api} from '../../api/ElectronicManagement'
  import TextTitle from '../../../components/Text/TextTitle'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      Breadcrumb,
      TextTitle,
    },
    name: 'modify-electronic-config',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧用电',
            name: 'electronic-over-view'
          }, {
            value: '收费配置',
          }],
        },
        maxlength: 32,
        collectionAccountList: [],
        aliAccountName: '',
        aliAccountNo: '',
        feeType: '1',
        feeTypeList: [
          {
            code: '1',
            name: '固定定价'
          }, {
            code: '2',
            name: '阶梯定价'
          }
        ],

        serviceFee: '0.0000',

        peakTime: ['00:00', '23:59'],
        peakObj: {
          elePayType: '1',
          startTime: '',
          endTime: '',
          unitPrice: '0.0000'
        },
        valleyTime: ['00:00', '23:59'],
        valleyObj: {
          elePayType: '2',
          startTime: '',
          endTime: '',
          unitPrice: '0.0000'
        },
        flatTime: ['00:00', '23:59'],
        flatObj: {
          elePayType: '3',
          startTime: '',
          endTime: '',
          unitPrice: '0.0000'
        },
        tipTime: ['00:00', '23:59'],
        tipObj: {
          elePayType: '4',
          startTime: '',
          endTime: '',
          unitPrice: '0.0000'
        },
        fixedObj: {
          elePayType: '5',
          startTime: '',
          endTime: '',
          unitPrice: '0.0000'
        },

        elePayTypeList: [
          {
            code: '1',
            name: '峰电'
          }, {
            code: '2',
            name: '谷电'
          }, {
            code: '3',
            name: '平电'
          }, {
            code: '4',
            name: '尖电'
          }
        ],
        ladderData: [
          {
            elePayType: '1',
            startTime: '',
            endTime: '',
            unitPrice: '0.0000',
            timeDataLine: ['00:00', '23:59'],
            showOnPage: true
          }, {
            elePayType: '1',
            startTime: '',
            endTime: '',
            unitPrice: '0.0000',
            timeDataLine: ['00:00', '23:59'],
            showOnPage: true
          }, {
            elePayType: '1',
            startTime: '',
            endTime: '',
            unitPrice: '0.0000',
            timeDataLine: ['00:00', '23:59'],
            showOnPage: true
          }, {
            elePayType: '1',
            startTime: '',
            endTime: '',
            unitPrice: '0.0000',
            timeDataLine: ['00:00', '23:59'],
            showOnPage: true
          }, {
            elePayType: '1',
            startTime: '',
            endTime: '',
            unitPrice: '0.0000',
            timeDataLine: ['00:00', '23:59'],
            showOnPage: false
          }, {
            elePayType: '1',
            startTime: '',
            endTime: '',
            unitPrice: '0.0000',
            timeDataLine: ['00:00', '23:59'],
            showOnPage: false
          }, {
            elePayType: '1',
            startTime: '',
            endTime: '',
            unitPrice: '0.0000',
            timeDataLine: ['00:00', '23:59'],
            showOnPage: false
          }, {
            showOnPage: false
          }
        ]
      }
    },
    created () {

    },
    mounted () {
      this.getElectricConfigData()
    },
    methods: {
      cel () {
        this.$router.push({
          name: 'electronic-config-center'
        })
      },
      dataLineUnitPriceChange (dataLine) {
        if (dataLine.unitPrice) {
          dataLine.unitPrice = parseFloat(dataLine.unitPrice).toFixed(4)
        } else {
          dataLine.unitPrice = '0.0000'
        }
      },

      fixedObjUnitPriceChange() {
        if (this.fixedObj.unitPrice) {
          this.fixedObj.unitPrice = parseFloat(this.fixedObj.unitPrice).toFixed(4)
        } else {
          this.fixedObj.unitPrice = '0.0000'
        }
      },

      fixedServiceFeeChange () {
        if (this.serviceFee) {
          this.serviceFee = parseFloat(this.serviceFee).toFixed(4)
        } else {
          this.serviceFee = '0.0000'
        }
      },

      addDataLine (dataLineIndex) {
        this.ladderData[dataLineIndex + 1].showOnPage = true
      },

      removeDataLine (dataLineIndex) {
        this.ladderData.length = this.ladderData.length - 1
        this.ladderData.splice(dataLineIndex, 1)
        let obj = {
          elePayType: '1',
          startTime: '',
          endTime: '',
          unitPrice: '0.00',
          timeDataLine: ['00:00', '23:59'],
          showOnPage: false
        }
        this.ladderData.push(obj)
        this.ladderData.push({
          showOnPage: false
        })
      },

      getElectricConfigData () {
        this.$axios.post(api.getElectricPayConfigList, {})
          .then(res => {
            let data = res.data.data
            if (data) {
              let electronicIndex = 0
              data.map(v => {
                this.feeType = v.feeType
                if (v.unitPrice) {
                  v.unitPrice = parseFloat(v.unitPrice).toFixed(4)
                } else {
                  v.unitPrice = 0.0000
                }
                if (v.elePayType === '5') {
                  this.fixedObj = v
                } else if (v.elePayType !== '6') {
                  if (v.startTime && v.endTime) {
                    this.ladderData[electronicIndex].timeDataLine[0] = v.startTime
                    this.ladderData[electronicIndex].timeDataLine[1] = v.endTime
                  }
                  this.ladderData[electronicIndex].showOnPage = true
                  this.ladderData[electronicIndex].unitPrice = v.unitPrice
                  this.ladderData[electronicIndex].elePayType = v.elePayType
                  // console.log(v.timeDataLine)
                  // v.showOnPage = true
                  // this.ladderData[electronicIndex] = v
                  electronicIndex ++
                }
                if (v.elePayType === '6') {
                  this.serviceFee = v.unitPrice || 0.0000
                }
              })
            }
          })
          .catch(errorHandler('获取收费数据失败'))
      },
      updateElectricPayConfig () {
        let arr = [this.fixedObj]
        this.ladderData.map(v => {
          if (v.timeDataLine && v.showOnPage) {
            if (v.timeDataLine.length === 2) {
              v.startTime = v.timeDataLine[0]
              v.endTime = v.timeDataLine[1]
              if (v.startTime && v.endTime && v.unitPrice) {
                arr.push(v)
              }
            }
          }
        })
        arr.map(arr => {
          arr.feeType = this.feeType
        })
        arr.push({
          elePayType: '6',
          startTime: '',
          endTime: '',
          unitPrice: this.serviceFee,
          feeType: this.feeType
        })
        this.$axios.post(api.updateElectricPayConfig, arr)
          .then(res => {
            nSuccess('修改成功')
            this.cel()
          })
          .catch(errorHandler('修改失败'))
      }
    },
    watch: {}
  }
</script>

<style scoped>
  .main_right {
    text-align: left;
  }
  .flexBox {
    display: flex;
    justify-content: space-between;
  }

  .flexBox a{
    line-height: 58px;
    margin-right: 40px;
    cursor: pointer;
    color: #00a0e6;
  }
  .flexBox a:hover{
    color: #06b3ff;
  }
  form {
    width: 100%;
    margin: 0 auto;
    text-align: left;
  }
  form>div {
    display: flex;
    justify-content: flex-start;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
    line-height: 30px;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 160px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>

<style lang="less">
  .main_right {
    .faceConfigTip {
      display: inline-block;
      min-width: 80px;
      text-align: right;
    }
    .faceConfigInput {
      display: inline-block;
      width: 313px;
      height: 28px;
      margin-left: 10px;
      .el-input__inner {
        height: 28px;
      }
    }
  }

  .electronic-config-modify {
    .el-date-editor .el-range-separator {
      width: 14px;
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ElectronicManagement/ElectronicConfig/ElectronicConfigModify.vue